import Section from '@components/atoms/Section';
import { Paragraph } from '@components/atoms/Typography';
import legal from '@lib/constants/legal';
import React from 'react';

const DisclaimerSection = () => (
  <Section>
    <div className="quote-resume-margin">
      <Paragraph style={{ fontSize: 14, lineHeight: 1.7 }}>
        {legal.brokerDisclaimer}
      </Paragraph>
    </div>
  </Section>
);

export default DisclaimerSection;
